import { VOICE_CAMPAIGN_STATUS } from 'shared/enum';

export const getDefaultBroadcastColumnKey = (cid: number, uid: number, botId: number) =>
	`default_broadcast_columns_${cid}_${uid}_${botId}`;

export const STOPPED_BY_USER_REASON = 'stopped_by_user';

export const getVoiceCampaignDisplayStatus = (status = '', statusReason = '') => {
	const normalizedStatus = status.trim().toUpperCase();
	const normalizedStatusReason = statusReason.trim().toLowerCase();

	if (normalizedStatus === VOICE_CAMPAIGN_STATUS.COMPLETED && normalizedStatusReason === STOPPED_BY_USER_REASON) {
		return VOICE_CAMPAIGN_STATUS.STOPPED;
	}

	return normalizedStatus;
};
